import WhatsappButton from "../../components/whatsappbutton";
import Helmets from "../../widgets/Helmet";
import style from "./noticias.module.css";
import Proyectos from "../../components/Proyectos";

const ProyectosDeAcuerdo: React.FC = () => {
  return (
    <>
      <Helmets />
      <main className={style.MasterBoxNoticias}>
        <WhatsappButton />
        <div className={style.Banner}>
          <div className={style.overlay}>PROYECTOS DE ACUERDO</div>
        </div>
        <div className={style.Content}>
          <Proyectos />          
        </div>
      </main>
    </>
  );
};

export default ProyectosDeAcuerdo;
